<!--
/****************************************************************************************************************
* ©2019 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
<div class="example-container">
  @if (showTotalRecords) {
    <div class="recordsCount">{{totalRecordsLabel}} : {{dataSourceSize}}</div>
  }
  <div>
    <!-- <mat-form-field class="filter">
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="{{filterLabel}}">
  </mat-form-field> -->
</div>
<mat-table #table [dataSource]="completeDataSource" matSort matSortActive="{{sortColumn}}"
  matSortDirection="{{sortOrder}}" matSortDisableClear="{{ sortDisableClear }}">

  <!--<ng-container matColumnDef="select" >
  <mat-header-cell *matHeaderCellDef>
    <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
    </mat-checkbox>
  </mat-header-cell>
  <mat-cell *matCellDef="let row">
    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
    </mat-checkbox>
  </mat-cell>
</ng-container>-->


@for (column of columns; track column) {
  <ng-container matColumnDef="{{column}}">
    <mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isSortingDisable(column)"
      arrowPosition="{{alignments[column]==='right' ? 'before': 'after' }}"
      [ngClass]="alignments[column]==='right'?{'align-right-header': true,'align-right-child': true}:'none'"
      attr.aria-label="{{ displayNames[column] }}">
    {{displayNames[column]}} </mat-header-cell>
    <mat-cell *matCellDef="let element" [ngClass]="alignments[column]==='right'?'align-right-cell':'none'">
      <span
        title="{{ column.indexOf('.') >= 0 ? element[column.split('.')[0]][column.split('.')[1]] : element[column] }}">
        {{ column.indexOf('.') >= 0 ? element[column.split('.')[0]][column.split('.')[1]] : element[column] }}
      </span>
    </mat-cell>
  </ng-container>
}
<ng-container matColumnDef="actionsColumn">
  <mat-header-cell *matHeaderCellDef attr.aria-label="{{ actionColumnName }}">
    {{actionColumnName}}
  </mat-header-cell>
  <mat-cell *matCellDef="let row">
    <div *PreAuthorize="'DynamicJavaEtlApi_getRecords'">
      @if (hasViewAction) {
        <i class="material-icons actionIcon" attr.aria-label="{{ viewLabel }}"
          (click)="performAction('view',row)" matTooltip='{{viewLabel}}'>
          remove_red_eye
        </i>
      }
    </div>
    <div *PreAuthorize="'DynamicJavaEtlApi_updateMasterRecords'">
      @if (hasEditAction) {
        <i class="material-icons actionIcon" attr.aria-label="{{ editLabel }}"
          matTooltip='{{editLabel}}' (click)="performAction('edit',row)">
          edit
        </i>
      }
    </div>
    <div *PreAuthorize="'DynamicJavaEtlApi_softDeleteRecords'">
      @if (hasDeleteAction) {
        <i class="material-icons actionIcon" attr.aria-label="{{ deleteLabel }}"
          matTooltip='{{deleteLabel}}' (click)="openConfirmationDialog(row)">
          delete
        </i>
      }
    </div>
  </mat-cell>
</ng-container>
<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
<mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'primary': row.isSelected}"
class="mat-table-align-items" (click)="selection.toggle(row)"></mat-row>
</mat-table>
@if (hasPaginator && pageSize) {
  <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    [length]="dataSourceSize" (page)="setPageSize($event)">
  </mat-paginator>
}
</div>
@if (showSpinner) {
  <div class="spinner-section">
    <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
}

